import _ from 'lodash';

const buildSectionItem = ({ section, attribute }) => ({
  section,
  label: _.capitalize(section),
  attribute,
});

export { buildSectionItem };
